import { BoxProps } from 'grommet';
import { Right } from 'lib/api';
import { RightInfoCard } from './RightInfoCard';
import { RightInfoItem } from './RightInfoItem';
import { RightInfoRow } from './RightInfoRow';

export type TermInformationProps = {
  background?: BoxProps['background'];
  right: Partial<Right>;
};

export const TermInformation = ({ background, right }: TermInformationProps) => {
  return (
    <RightInfoCard title="Term Information" background={background}>
      <RightInfoRow>
        <RightInfoItem title="Term From" value={right.termFromDate || 'Not specified'} />
        <RightInfoItem title="Term To" value={right.termToDate || 'Not specified'} />
        <RightInfoItem title="Media" value={right.media || 'Not specified'} />
        <RightInfoItem title="Territories" value={right.territories || 'Not specified'} />
      </RightInfoRow>
    </RightInfoCard>
  );
};
